import React, { useEffect, useState } from 'react';
import GridInputs from '../../../components/common/inputs/GridInputs';
import { IData } from './helpers/Interface';
import axios from 'axios';
import { SubmitButton } from '../../../components/common/button/CustomButtons';
import useConfirm from '../../../components/common/useConfirm';
import CustomSelect from '../../../components/common/SelectField';
import { MenuItem } from '@mui/material';
import SelectGridMui from '../../../components/common/selectscustom/SelectGridMui';

const Create = ({
  id,
  setIsModal,
}: {
  id?: string | null;
  setIsModal: React.Dispatch<React.SetStateAction<boolean>>;
}) => {
  const [defectData, setDefectData] = useState<any>({
    breakdown_name: null,
  });
  const [render, setRender] = useState(false);
  const [isSubmit, setIsSubmit] = useState(false);

  const [DialogSubmit, confirmSubmit] = useConfirm(
    `${id ? 'Update Breakdown' : 'Create Breakdown'}`,
    `Are you sure you want to ${id ? 'update' : 'save'} this?`
  );
  useEffect(() => {
    if (id) {
      axios
        .get(`/api/masterListOfBreakdown/${id}`)
        .then((res) => setDefectData(res.data))
        .catch((err) => console.log(err));
    }
  }, [id]);

  function handleDefectData(e: React.ChangeEvent<HTMLInputElement>) {
    setDefectData((prev: any) => ({
      ...prev,
      [e.target.name]: e.target.value,
    }));
  }

  const handleSumbit = async () => {
    setIsSubmit(true);
    const ans = await confirmSubmit();
    if (!ans) return;
    if (id) {
      await axios
        .put(`/api/masterListOfBreakdown/${id}`, defectData)
        .then((res) => {
          setIsSubmit(false);
          setIsModal(false);
        })
        .catch((err) => console.log(err));
    } else {
      await axios
        .post('/api/masterListOfBreakdown', defectData)
        .then((res) => {
          setIsSubmit(false);
          setIsModal(false);
        })
        .catch((err) => {
          setIsSubmit(false);
          console.log(err);
        });
    }
  };

  return (
    <>
      <GridInputs
        id={'breakdown_name'}
        name={'breakdown_name'}
        html_for={'breakdown_name'}
        label_name={'BREAKDOWN NAME:'}
        input_type={'text'}
        focusType={'onblur'}
        value={defectData?.breakdown_name || ''}
        onChange={handleDefectData}
      />
       <SelectGridMui
        name="type"
        value={defectData?.type || ''}
        lable={'BREAKDOWN TYPE:'}
        onChange={(e:any)=>handleDefectData(e)}
      >
        <MenuItem value="ELECTRICAL">ELECTRICAL</MenuItem>
        <MenuItem value="MECHANICAL">MECHANICAL</MenuItem>
      </SelectGridMui>
      <div
        className="btn_save"
        style={{
          position: 'absolute',
          right: '140px',
          top: '-0.6px',
        }}
      >
        <SubmitButton
          label={`${id ? 'update' : 'submit'}`}
          type="button"
          onClick={handleSumbit}
        />
      </div>
      <DialogSubmit />
    </>
  );
};

export default Create;
